import { getUnlocalizedSpecificationItem } from "../../../../../../utils/mappers/server-to-client/utils/get-unlocalized-specification-item.js";
import { getSpecificationItems } from "../../../../../../utils/mappers/server-to-client/utils/get-specification-items.js";
const getSharedFrameSpecificationItems = ({
  segment,
  trend,
  lensFeatures,
  frameFeatures,
  prescriptionGlass
}) => {
  const { lensColor, isGlazeble, isPolarized, isGradient, isMirror } = lensFeatures || {};
  const {
    color: frameColor,
    colorAllLocales: frameColors,
    shape: frameShape,
    material: frameMaterial,
    materialAllLocales: frameMaterials,
    type: frameType,
    typeAllLocales: frameTypes,
    size: frameSize,
    templeType,
    templeColor
  } = frameFeatures || {};
  const frameColorUnlocalized = getUnlocalizedSpecificationItem(frameColors);
  const frameMaterialUnlocalized = getUnlocalizedSpecificationItem(frameMaterials);
  const frameTypeUnlocalized = getUnlocalizedSpecificationItem(frameTypes);
  const frameShapeUnlocalized = getUnlocalizedSpecificationItem(frameShape?.displayNameAllLocales);
  const serverSpecifications = {
    segment,
    frameShape: frameShape?.displayName,
    frameShapeUnlocalized,
    lensColor,
    frameColor,
    frameColorUnlocalized,
    frameMaterial,
    frameMaterialUnlocalized,
    frameType,
    frameTypeUnlocalized,
    frameSize: frameSize?.displayName,
    isGlazeble,
    isPolarized,
    isMirror,
    isGradient,
    templeType,
    templeColor,
    trend,
    prescriptionGlass
  };
  return getSpecificationItems(serverSpecifications);
};
export {
  getSharedFrameSpecificationItems
};
//# sourceMappingURL=get-shared-frame-specification-items.js.map
